import { html } from '@nrk/dh-server-libs/html'
import { sanitizeAttribute, sanitizeText } from '../../../lib/sanitize'
import { renderAltText } from './alt-text'
/* eslint-disable import/no-duplicates */
import isToday from 'date-fns/isToday'
import format from 'date-fns/format'
/* eslint-enable import/no-duplicates */
import styles from './poll.module.css'
import cardStyles from './shared/card.module.css'
import paddingStyles from '../main-content-padding.module.css'
import contentStyles from '../main-content.module.css'
import { CardConfig, PollCard } from '../../../types/types'

const s = { ...styles, ...cardStyles, ...paddingStyles, ...contentStyles }

export function getPollClass(hasImage) {
  return hasImage ? s.pollCardWithImage : ''
}

export function renderPollCard(card: PollCard, config: CardConfig) {
  const { poll } = card

  const pollUrl = process.env.POLL_URL
  const pollId = `nsc:${poll.id}`
  const pollStart = Date.parse(poll.start)
  const isDisabled = Date.now() < Date.parse(poll.start)

  let label
  if (poll.start && Date.now() < pollStart) {
    if (isToday(pollStart)) {
      label = `Avstemningen åpner ${format(pollStart, 'HH:mm')}`
    } else {
      label = `Avstemningen åpner ${format(pollStart, 'dd.MM.yy')}`
    }
  } else if (poll.end && Date.now() > Date.parse(poll.end)) {
    label = 'Avstemningen er over'
  } else {
    label = 'Avstemning'
  }

  const classes = config.classes
  return html` <!-- Poll card ${config.index} -->
    ${renderAltText(config.altText)}
    <div
      class="${s.card} | ${s.pollCard} ${classes.block} | ${s.pollTheme} ${s.mainContentGrid} ${s.mainContentPadding} ${classes.utility}"
      ${config.attributes}
    >
      <div
        class="${s.content} fade-text measure-text"
        role="group"
        aria-labelledby="poll-heading-${config.backgroundId}"
      >
        <dhks-poll
          poll-id="${pollId}"
          poll-url="${pollUrl}"
          poll-end="${poll.end}"
          poll-start="${poll.start}"
          class="${s.poll}"
        >
          <div class="${s.label}">${renderSvg()} ${label}</div>
          <div class="${s.pollContainer}">
            <h2
              class="${isDisabled ? `${s.disabled}` : ''}"
              id="poll-heading-${config.backgroundId}"
            >
              ${sanitizeText(poll.question)}
            </h2>
            <div data-poll-content>
              <div class="${s.answerGrid}">
                ${poll.answers
                  .map(
                    (answer) =>
                      html`<button
                        class="${s.answer}"
                        value="${sanitizeAttribute(answer.key)}"
                        disabled
                        title="Trykk for å stemme"
                      >
                        ${sanitizeText(answer.text)}
                      </button>`,
                  )
                  .join('')}
              </div>
              <button value="show-answers" disabled>Vis resultat</button>
            </div>
          </div>
        </dhks-poll>
      </div>
    </div>`
}

export function renderPollResult({ percentage, total, alternatives, altId }) {
  return html`
    <div>
      <ul class="${s.answerGrid}" role="list">
        ${alternatives
          .map((alt) => {
            const hasVoted = !!altId
            const vote = percentage[alt.value] || 0
            let voteType = ''
            if (hasVoted && altId === alt.value) {
              voteType = s.chosenAlternative
            }

            return html`<li
              class="${s.pollResult} "
              role="listitem"
              style="--vote-percent:${vote}%;"
              tabindex="-1"
              data-sr-fix-ignore-focus
            >
              <div class="${s.alternative}" role="text">${alt.text}</div>
              <div class="${s.bar} ${voteType}"></div>
              <div class="${s.percentage}">${vote.toFixed(0)} %</div>
            </li>`
          })
          .join('')}
      </ul>
      <div class="${s.total}" tabindex="-1" data-sr-fix-ignore-focus>${total} stemmer</div>
    </div>
  `
}

function renderSvg() {
  return html` <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="${s.path}"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10 3H14V21H10V3ZM3 13H7V21H3V13ZM21 8H17V21H21V8Z"
    />
  </svg>`
}
